import { UserLoginForm } from '../../../components/forms/user_login'
import login_banner from '../../../assets/images/banner.png'
import logo from '../../../assets/images/rexoasset.png'
import Aos from 'aos'
import 'aos/dist/aos.css'

export const LoginImport = {
    login_banner,
    logo,
    UserLoginForm,
    Aos,
}